import React from 'react';
import CoursesTableSection from './table-section/section';

export default function CoursesTab() {
  return <CoursesTableSection />;
}
